module.exports = __webpack_public_path__ + "img/1.0ee681a2.jpg";